/** @jsx isolateComponent */
import { ReactNode } from 'react';
import { Interpolation } from '@emotion/css';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * Children to render within the loader, typically
   * `SkeletonBlock` and `SkeletonText` components that
   * are wrapped in a layout component.
   */
  children: ReactNode;
};

const Styles = labelStyles('SkeletonLoader', {
  root: {
    display: 'block',
    overflow: 'hidden',
  },
});

/**
 * Renders an abstract representation of a component, typically
 * while that component is loading.
 */
export const SkeletonLoader = (props: Props) => {
  return <div css={Styles.root as Interpolation}>{props.children}</div>;
};
